//@ts-nocheck
import React, { useEffect, useState } from 'react';
import Bookingpnrlist from '././Bookingpnrlist';
import calender from "../bookingConfirmation/Images/calender.svg";
import { useSelector, useDispatch } from "react-redux";
import {setFlightTypeCheck} from '../bookingConfirmation/ActionCreator/searchForm';
import { getLastTwelveMonths, formattedDate, getLastSixMonths, changeDateFormat, endTimeDate, getLastFourWeeks, getLastSevenDays, formattedEndDate } from "../bookingConfirmation/Utils/CommenFunction"
import { getMyFileSearchByPNR, getMyFiles } from "../bookingConfirmation/thunks/getMyFiles"
import { resetMyFilesFilters } from '../bookingConfirmation/ActionCreator/myFiles';
import { parseISO } from 'date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import 'date-fns';
import Collapse from 'react-bootstrap/Collapse'
import { Tabs, Tab } from "react-bootstrap";
import moment from 'moment';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import swal from 'sweetalert';
import { CheckBox } from '../../components/common components/Checkbox';

export default function Searchbooking(props) {
  const flightType1 = useSelector((state) => state.searchForm.flightType);
  const myFiles = useSelector((state) => state.myFile.myFilesData);
  const [myFilesData, setMyFiles] = useState([])
  const [selectOption, setSelectOption] = useState("Last 4 Weeks")
  const [datePeriod, setDatePeriod] = useState({ from: formattedDate(new Date()), to: formattedDate(new Date()) })
  const [filterOption, setFilterOption] = useState("booking")
  const [isVirtuosoBookings, setIsVirtuosoBookings] = useState(false)
  const [isGoldenTicketBookings, setIsGoldenTicketBookings] = useState(false)
  const [isFilterChnaged, setFilterChanges] = useState(false)
  const [customDate, setCustomDate] = useState({ from: formattedDate(new Date()), to: formattedDate(new Date()) })
  const [open, setOpen] = useState(false)
  const [openD, setOpenD] = useState(false)
  const [bookingCode, setStatusCode] = useState("All")
  const dispatch = useDispatch()
  const orgId = useSelector((state) => state.agentProfile.orgId);
  const agencyId = useSelector((state) => state.agentProfile.agencyId);
  const agencyGroupId = useSelector((state) => state.agentProfile.agencyGroupId);
  const agentInfo = useSelector((state) => state.agentProfile.agentDetails);
  const agencyDetails = useSelector((state) => state.agentProfile.agencyDetails);
  const isInternalUserAutheticated = useSelector((state) => state.internalUser.isInternalUserAutheticated);
  const agencyField = useSelector((state) => state.searchForm.agencyField)
  const [isResult, setResult] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [skipFirstRender,setSkipFirstRender] = useState(false)
  const [initialResult, setInitialResult] = useState({})
  const [initialPayload, setInitialPayload] = useState({})
  let backupOrgId = localStorage.getItem("orgId");
  const [searchText,setSearchData] = useState("")
  const [tabName, setTabName] = useState("allFiles");
  const [initialSearch, setInitialSearch] = useState(true);
  const [displayMyFiles, setDisplayMyFiles] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState({ page: 0, count: 0 });
  const sortByBookingDate = () => {
    setMyFiles([])
    setResult(false)
    setFilterOption("booking")
    if(selectOption === "Last 4 Weeks"){
      let dateObj = getLastFourWeeks()
      setDatePeriod(dateObj)
      getFilteredData("booking", dateObj.from, dateObj.to)
    }else{
      getFilteredData("booking", datePeriod.from, datePeriod.to)
    }
  }

  const sortByDepartureDate = () => {
    setMyFiles([])
    setResult(false)
    setFilterOption("departure")
    if(selectOption === "Last 4 Weeks"){
      let dateObj = getLastFourWeeks()
      setDatePeriod(dateObj)
      getFilteredData("departure", dateObj.from, dateObj.to)
    }else{
    getFilteredData("departure", datePeriod.from, datePeriod.to)
    }
  }

  const handleSelect = (e) => {
    setSelectOption(e)
    setMyFiles([])
    setResult(false)
    let dateObj = {}
    dispatch(resetMyFilesFilters(true))
    setOpen(false)
    if (e === "Today") {
      let date = formattedDate(new Date())
      let endDate = formattedEndDate(new Date())
      dateObj.from = date
      dateObj.to = endDate
      setDatePeriod(dateObj)
      getFilteredData(filterOption, date, endDate)
    }

    if (e === "Yesterday") {
      var currentDate = new Date();
      var yesterdayDate = currentDate.setDate(currentDate.getDate() - 1);
      let date = formattedDate(new Date(yesterdayDate))
      let endDate = formattedEndDate(new Date(yesterdayDate))
      dateObj.from = date
      dateObj.to = endDate
      setDatePeriod(dateObj)
      getFilteredData(filterOption, dateObj.from, dateObj.to)
    }
    if (e === "Last 7 Days") {
      dateObj = getLastSevenDays()
      setDatePeriod(dateObj)
      getFilteredData(filterOption, dateObj.from, dateObj.to)
    }

    if (e === "Last 4 Weeks") {
      dateObj = getLastFourWeeks()
      setDatePeriod(dateObj)
      getFilteredData(filterOption, dateObj.from, dateObj.to)
    }
    if (e === "Last 6 Months") {
      dateObj = getLastSixMonths()
      setDatePeriod(dateObj)
      getFilteredData(filterOption, dateObj.from, dateObj.to)
    }
    if (e === "Last 12 Months") {
      dateObj = getLastTwelveMonths()
      setDatePeriod(dateObj)
      getFilteredData(filterOption, dateObj.from, dateObj.to)
    }
    if(e === "customDate"){
      setCustomDate({ from: changeDateFormat(new Date(), "dashed"),to: changeDateFormat(new Date(), "dashed") })
    }

  }

  const getFilteredData = async (option, fromDate, toDate) => {
    if(!props.agencyFlag) return
    let from = option ? option + "FromDate" : filterOption + "FromDate"
    let to = option ? option + "ToDate" : filterOption + "ToDate"
    let requestPayload = {}
    setIsLoading(true)
    dispatch(resetMyFilesFilters(true))
    if (bookingCode === "All") {
      requestPayload = {
        organizationId: orgId !== "" ? orgId : backupOrgId,
        agencyId: agencyId,
        agencyGroupId: agencyId && agencyGroupId ? agencyGroupId: undefined,
        [from]: fromDate,
        [to]: toDate,
        agentUserName: isInternalUserAutheticated ? (agencyField?.value?.allowEdocsSharing || agencyDetails?.allowEdocsSharing) ? undefined : (agentInfo?.username || undefined) : agencyDetails?.allowEdocsSharing ? undefined : (agencyDetails?.username || undefined)
      }
    } else {
      requestPayload = {
        organizationId: orgId !== "" ? orgId : backupOrgId,
        agencyId: agencyId,
        agencyGroupId: agencyGroupId,
        [from]: fromDate,
        [to]: toDate,
        bookingStatusCodes: bookingCode === "NTC" ?  [bookingCode,"TC","PNTC"] : [bookingCode],
        agentUserName: isInternalUserAutheticated ? (agencyField?.value?.allowEdocsSharing || agencyDetails?.allowEdocsSharing) ? undefined : (agentInfo?.username || undefined) : agencyDetails?.allowEdocsSharing ? undefined : (agencyDetails?.username || undefined)
      }
    }


    let myfilesResult = await dispatch(getMyFiles(requestPayload, isVirtuosoBookings, isGoldenTicketBookings))
    if (myfilesResult) {
      setInitialResult(myfilesResult)
      setInitialPayload(requestPayload)
      setIsLoading(false)  
      let data = myfilesResult.bookings
      if (option == "departure") {
        setMyFiles(data && data.sort((a, b) => { return new Date(b.departureDate) - new Date(a.departureDate) }))
        setResult(true)
      } 
      if (option == "booking") {
        setMyFiles(data && data.sort((a, b) => { return new Date(b.bookingDate) - new Date(a.bookingDate) }))
        setResult(true)
      }


    } else {
      setIsLoading(false)
    }

  }


  const handleDateChange = (date, key) => {
    setSelectOption("customDate")
    let obj = { ...customDate, [key]: changeDateFormat(date, "dashed") }
    setDatePeriod(obj)
    setCustomDate({ ...customDate, [key]: changeDateFormat(date, "dashed") })
  }

  const openCollapse = () => {
    setOpen(!open)
  }

  const openCollapseForD = () => {
    setOpenD(!openD)
  }

  useEffect(() => {
    setMyFiles(myFiles)
  }, [myFiles])

  const getCustomDateData = (option, customDate) => {
   
    let formatedFromDate = formattedDate(new Date(parseISO(customDate.from)))
    let formatedToDate = formattedEndDate(new Date(parseISO(customDate.to)))
    let dateObj = {}
    dateObj.from = formatedFromDate
    dateObj.to = formatedToDate
    setDatePeriod(dateObj)
    getFilteredData(option, formatedFromDate, formatedToDate)
  }
  const setBookingCode = (code) => {
    setStatusCode(code)
  }

  useEffect(() => {
    setMyFiles([])
    if (props.keyName === "sortby" && skipFirstRender) {
      sortByBookingDate()
    }
  }, [props.keyName])

  useEffect(() => {
    setMyFiles([])
    sortByBookingDate()
    setSkipFirstRender(true)
  }, [agentInfo?.username])

  useEffect(async () => {
    if(skipFirstRender)
    sortByBookingDate()
  }, [agencyId])


  
  const CONFIG = {
    "Sabre": { showAirlineRecordLocator: false, showWebIndicator: false },
    "Sabre_NDC": { showAirlineRecordLocator: false, showWebIndicator: true },
    "Amadeus_NDC": { showAirlineRecordLocator: false, showWebIndicator: true },
    "NDC": { showAirlineRecordLocator: false, showWebIndicator: true },
    "HS_NDC_Aggregator": { showAirlineRecordLocator: false, showWebIndicator: true },
    "TwoOneWay": { showAirlineRecordLocator: false, showWebIndicator: false },
    "TwoOneWayNDC": { showAirlineRecordLocator: false, showWebIndicator: true }
  }

  const myFilesBookingStatus = {
    "NP": "ON HOLD",
    "PNP": "PAID",
    "PT": "TICKETED",
    "NTC": "CANCELLED",
    "TC": "CANCELLED",
    "PNTC": "CANCELLED",
    "CR": "CANCELLED",
    "CU": "CONTACT US",
    "SC": "SCHEDULE CHANGE",
    "TF": "TICKETING FAILED",
    "PD": "PAID"
  }

  const displayProviderName = [
    { key: "Sabre", value: "Sabre GDS" },
    { key: "Sabre_NDC", value: "Sabre NDC" },
    { key: "Amadeus_NDC", value: "Amadeus NDC" },
    { key: "NDC", value: "Duffel" },
    { key: "HS_NDC_Aggregator", value: "HIS NDC" }
  ]

  const providerNameMap = Object.fromEntries(
    displayProviderName.map((item) => [item.key, item.value])
  );

  const EXCLUDED_STATUS_CODES = ["BA", "UKN", "BF"];

  const buildExportPayload = () => {
    const from = filterOption + "FromDate";
    const to = filterOption + "ToDate";
    const agentUserName = isInternalUserAutheticated
      ? (agencyField?.value?.allowEdocsSharing || agencyDetails?.allowEdocsSharing)
        ? undefined
        : (agentInfo?.username || undefined)
      : agencyDetails?.allowEdocsSharing
        ? undefined
        : (agencyDetails?.username || undefined);

    const requestPayload = {
      organizationId: orgId !== "" ? orgId : backupOrgId,
      agencyId: agencyId,
      agencyGroupId: agencyId && agencyGroupId ? agencyGroupId : undefined,
      [from]: datePeriod?.from,
      [to]: datePeriod?.to,
      agentUserName,
    };

    if (bookingCode !== "All") {
      requestPayload.bookingStatusCodes =
        bookingCode === "NTC"
          ? [bookingCode, "TC", "CR", "PNTC"]
          : bookingCode === "PNP"
            ? [bookingCode, "TF", "PD", "PM"]
            : [bookingCode];
    }

    return requestPayload;
  };

  const buildExportRows = (bookings) => {
    const csvRows = [["Status", "Reservation Date", "Departure Date", "Passenger", "Agency Code", "Agency Name", "Agent Name", "Carrier", "Provider", "PNR Number"]];
    const excelRows = [];

    (bookings || []).forEach((myFiles) => {
      if (!myFiles?.pnr) return;
      if (EXCLUDED_STATUS_CODES.includes(myFiles?.bookingStatusCodeSearchText)) return;

      const provider =
        myFiles?.providerName === "Sabre" || myFiles?.providerName === "Sabre_Prod"
          ? "Sabre"
          : myFiles?.providerName?.includes(",") && myFiles?.providerName?.includes("NDC")
            ? "TwoOneWayNDC"
            : myFiles?.providerName === "TwoOneWay" || myFiles?.providerName?.includes(",")
              ? "TwoOneWay"
              : myFiles?.providerName;

      const configuration = CONFIG?.[provider] ?? {};

      const convertedBookingDate =
        myFiles?.bookingDate &&
        moment.tz(myFiles.bookingDate, "America/Chicago").tz("America/New_York");

      const status =
        myFilesBookingStatus?.[myFiles.bookingStatusCodeSearchText] ||
        myFiles.bookingStatusDetail?.description ||
        myFiles.bookingStatus;

      const reservationDate = convertedBookingDate
        ? `${convertedBookingDate.format("DD MMM YYYY")} ${convertedBookingDate.format("HH:mm:ss")} ET`
        : changeDateFormat(myFiles.bookingDate, "monthFormat");

      const departureDate = myFiles?.departureDate
        ? moment(changeDateFormat(myFiles.departureDate, "monthFormat")).format("DD MMM YYYY")
        : "";

      const passengers = myFiles?.paxNames
        ? myFiles.paxNames.split(",").map((p) => p.trim()).join(" | ")
        : "";

      const providerDisplay = providerNameMap?.[myFiles.providerName] ?? myFiles.providerName;

      const pnrNumber =
        configuration?.showAirlineRecordLocator && myFiles?.airlineRecordLocator
          ? `${myFiles.airlineRecordLocator} (${myFiles.pnr})`
          : myFiles.pnr;

      const indicators = [
        configuration?.showWebIndicator ? "WEB.NDC" : "",
        myFiles?.linkedPNR ? "2OneWay" : "",
      ]
        .filter(Boolean)
        .join(" ");

      const pnrDisplay = `${pnrNumber}${indicators ? " " + indicators : ""}`;

      csvRows.push([
        status || "",
        reservationDate || "",
        departureDate || "",
        passengers || "",
        myFiles?.agencyCode || "",
        myFiles?.agencyName || "",
        myFiles?.agentName || "",
        myFiles?.validatingCarrier || "",
        providerDisplay || "",
        pnrDisplay,
      ]);

      excelRows.push({
        status: status || "",
        reservationDate: reservationDate || "",
        departureDate: departureDate || "",
        passengers: passengers || "",
        agencyCode: myFiles?.agencyCode || "",
        agencyName: myFiles?.agencyName || "",
        agentName: myFiles?.agentName || "",
        carrier: myFiles?.validatingCarrier || "",
        providerDisplay: providerDisplay || "",
        pnrNumber: pnrDisplay,
      });
    });

    return { csvRows, excelRows };
  };

  const downloadCsv = (csvRows, filename) => {
    const escapeCell = (cell) => {
      const value = cell == null ? "" : String(cell);
      if (/[",\n\r]/.test(value)) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      return value;
    };
    const content = csvRows.map((row) => row.map(escapeCell).join(",")).join("\n");
    const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `${filename}.csv`);
  };

  const downloadExcel = async (excelRows, filename) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet A");
    worksheet.columns = [
      { header: "Status", key: "status", width: 16 },
      { header: "Reservation Date", key: "reservationDate", width: 28 },
      { header: "Departure Date", key: "departureDate", width: 16 },
      { header: "Passenger", key: "passengers", width: 28 },
      { header: "Agency Code", key: "agencyCode", width: 14 },
      { header: "Agency Name", key: "agencyName", width: 24 },
      { header: "Agent Name", key: "agentName", width: 20 },
      { header: "Carrier", key: "carrier", width: 12 },
      { header: "Provider", key: "providerDisplay", width: 16 },
      { header: "PNR Number", key: "pnrNumber", width: 22 },
    ];
    excelRows.forEach((row) => worksheet.addRow(row));
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${filename}.xlsx`);
  };

  const handleExport = async (format) => {
    if (isExporting || !props.agencyFlag) return;
    if (!datePeriod?.from || !datePeriod?.to) {
      swal("Select a date range before exporting.", { icon: "error" });
      return;
    }

    setIsExporting(true);
    setExportProgress({ page: 0, count: 0 });

    try {
      const requestPayload = buildExportPayload();
      const myfilesResult = await dispatch(
        getMyFiles(requestPayload, isVirtuosoBookings, isGoldenTicketBookings, {
          mode: "export",
          onProgress: (info) => setExportProgress(info),
        })
      );

      if (!myfilesResult?.bookings) {
        swal("Export failed. Please try again.", { icon: "error" });
        return;
      }

      const { csvRows, excelRows } = buildExportRows(myfilesResult.bookings);
      if (excelRows.length === 0) {
        swal("No bookings found to export for the selected filters.", { icon: "info" });
        return;
      }

      const filename = moment().format("MMMM_Do_YYYY_h_mm");
      if (format === "csv") {
        downloadCsv(csvRows, filename);
      } else {
        await downloadExcel(excelRows, filename);
      }
    } catch (err) {
      console.error("My Files export failed", err);
      swal("Export failed. Please try again.", { icon: "error" });
    } finally {
      setIsExporting(false);
      setExportProgress({ page: 0, count: 0 });
    }
  };

  const setSeachText=(e)=>{
      setSearchData(e.target.value)
    }

    const getSearchResult=async()=>{
      setInitialSearch(false)
      let str ="" 
      if(searchText.length===0){
        //swal(`Please enter PNR.`, { icon: "error" });
         console.log("Please enter PNR");
        
      }
      let requestPayload = {
          "recordLocator":String(searchText).trim() 
      }
    
      setIsLoading(true)
      let myfilesResult = await dispatch(getMyFileSearchByPNR(requestPayload))
    
      if(myfilesResult=="error" && searchText && searchText.length > 0){
        console.log("Request has timed out, please use Additional Filter to narrow down search results")
      }
      if(myfilesResult){
        setMyFiles(myfilesResult.bookings && myfilesResult.bookings.length===0?[]:myfilesResult.bookings)
      }
      setIsLoading(false)
    }

    const handleKeypress = e => {
      if (e.charCode === 13) {
        getSearchResult();
      }
    }  

      const getTabName = (k) => {
        setTabName(k);
        if(k=="search_by"){
          setMyFiles([])
          setIsLoading(false)
          setInitialSearch(true)
        }
      };  

      useEffect(() => {
        window.isVirtuoso = () => {
          return isVirtuosoBookings
        }
        window.isGoldenTicket = () => {
          return isGoldenTicketBookings
        }
        sortByBookingDate()
      },[isVirtuosoBookings, isGoldenTicketBookings])

  return (
    <>
      <div className=" searchbyinput" style={{ position: "relative" }}>
        
        <Tabs defaultActiveKey="allFiles" id="uncontrolled-tab-example" className="firsttabmy"
          onSelect={getTabName}>
            <Tab eventKey="allFiles" title={"All Files"}>
              <div style={{marginTop:"10px", padding:"15px", boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"}}>
        <div className="datewiseview">
          <div className="bd-pi-formcol pi-formcol-2 mf-filter-row" >

            <>
            
              <span className="mf-filter-label">Show Bookings Done</span>
              <button
                onClick={openCollapse}
                aria-controls="example-collapse-text"
                aria-expanded={open}
                className="mf-filter-btn"
              > <img src={calender} />
                {/* {selectOption} */}
                {selectOption === "customDate" ? "Custom Date" : selectOption}
              </button>
              <Collapse in={open}>
                <div id="example-collapse-text" className="mf-filter-collapse">

                  <div onClick={() => handleSelect("customDate")}><span className="dropditem">Custom Date</span></div>
                  <div onClick={() => handleSelect("Today")} ><span className="dropditem">Today</span></div>
                  <div onClick={() => handleSelect("Yesterday")} ><span className="dropditem">Yesterday</span></div>
                  <div onClick={() => handleSelect("Last 7 Days")} ><span className="dropditem">Last 7 Days</span></div>
                  <div onClick={() => handleSelect("Last 4 Weeks")} ><span className="dropditem">Last 4 Weeks</span></div>
                  <div onClick={() => handleSelect("Last 6 Months")} ><span className="dropditem">Last 6 Months</span></div>
                  <div onClick={() => handleSelect("Last 12 Months")} ><span className="dropditem">Last 12 Months</span></div>
                </div>
              </Collapse>
            </>
          </div>


          

            <>
            {selectOption === "customDate" && <div eventKey="customDate">
              <p className="dropditemp">
                <div className="bd-pi-input pi-input-date ">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableFuture={filterOption == 'booking' ? true : false}
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      id="birth_date"
                      required
                      label="From"
                      margin="normal"
                      format="MM/dd/yyyy"
                      name="from"
                      value={customDate && parseISO(customDate.from)}
                      onChange={date => handleDateChange(date, "from")}
                    />
                  </MuiPickersUtilsProvider>
                </div>

                <div className="bd-pi-input pi-input-date">
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableFuture={filterOption == 'booking' ? true : false}
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      id="birth_date"
                      required
                      label="To"
                      margin="normal"
                      format="MM/dd/yyyy"
                      name="to"
                      value={customDate && parseISO(customDate.to)}
                      onChange={date => handleDateChange(date, "to")}
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div className="bd-pi-input pi-input-date ">
                  <button type="button" className="btn viewbuttonmyfile" onClick={() => getCustomDateData(filterOption, customDate)}>View</button>
                </div>
              </p>
            </div>} </>

            <div className=" pnrbooking" style={{ display: "flex", alignItems: "center", gap: "12px", pointerEvents: (displayMyFiles.length === 0 || isExporting) ? "none" : undefined, opacity: (displayMyFiles.length === 0 || isExporting) ? 0.6 : 1 }}>

            <div className='customizeTab'>
              <span
                role="button"
                tabIndex={0}
                onClick={() => handleExport("csv")}
                onKeyPress={(e) => { if (e.key === "Enter") handleExport("csv"); }}
                style={{ cursor: isExporting ? "wait" : "pointer" }}
              >
                CSV
              </span>
            </div>
            <div className='customizeTab'>
              <span
                role="button"
                tabIndex={0}
                onClick={() => handleExport("excel")}
                onKeyPress={(e) => { if (e.key === "Enter") handleExport("excel"); }}
                style={{ cursor: isExporting ? "wait" : "pointer" }}
              >
                Excel
              </span>
            </div>
            {isExporting && (
              <span style={{ fontSize: "13px", color: "#555", whiteSpace: "nowrap" }}>
                Fetching bookings{exportProgress.page ? `… page ${exportProgress.page}` : "…"}
                {exportProgress.count ? ` (${exportProgress.count})` : ""}
              </span>
            )}
          
            </div>
          </div> 
          </div>
            </Tab>
          {/* <Tab eventKey="search_by" title={"Search By"}>
            <div style={{ marginTop: "10px", padding: "15px", boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }}>
              <div className="datewiseview inputpnr">
                <label style={{padding:"7px"}} for="inlineRadio1"><strong>{'PNR'}</strong></label>
                <input type="text" placeholder=" " id="pnr" name="searchText" onChange={setSeachText} onKeyPress={handleKeypress} />
                <button type="button" className="btn viewbuttonmyfile" onClick={getSearchResult}>{'Search'}</button>
              </div>
            </div>
          </Tab> */}
          </Tabs>

          <div className="pnrstatus">
          <div className="form-check">
            <CheckBox label="Virtuoso Bookings" checked={isVirtuosoBookings} onChange={() => {
              const next = !isVirtuosoBookings;
              setIsVirtuosoBookings(next);
              if (next) setIsGoldenTicketBookings(false);
            }} />
          </div>
          <div className="form-check">
            <CheckBox label="Golden Ticket" checked={isGoldenTicketBookings} onChange={() => {
              const next = !isGoldenTicketBookings;
              setIsGoldenTicketBookings(next);
              if (next) setIsVirtuosoBookings(false);
            }} />
          </div>
          

        </div>
        

        </div>



      <Bookingpnrlist myFilesData={myFilesData} filter={tabName=="allFiles"?"sortBy":"search_by"} filterOption={filterOption} date={datePeriod} bookingStatusCode={(k) => setBookingCode(k)} isResult={isResult} isLoading={isLoading} initialResult={initialResult} initialPayload={initialPayload} setDisplayMyFiles={setDisplayMyFiles} isVirtuosoBookings={isVirtuosoBookings} isGoldenTicketBookings={isGoldenTicketBookings}/>

    </>
  )
      
      }
